<template>
  <div class="notifications-panel">
    <div class="notifications-panel__header">
      <div class="notifications-panel__title">
        <NotificationIcon class="notifications-panel__title-icon" />
        <div class="notifications-panel__title-text">{{ $t('notifications.title') }}</div>
      </div>
      <div class="notifications-panel__close">
        <LLButton small tertiary>
          <template #icon-left>
            <CloseRegularIcon class="notifications-panel__close-icon" @click.native="$emit('close')" />
          </template>
        </LLButton>
      </div>
    </div>
    <div class="notifications-panel__push-setup">
      <i18n path="notifications.push_setup.intro" tag="p" class="notifications-panel__push-setup-text">
        <template #link>
          <a
            class="notifications-panel__push-setup-link"
            :href="helpNotificationsUrl"
            target="_blank"
            rel="noopener noreferrer"
            >{{ $t('notifications.push_setup.link') }}</a
          >
        </template>
      </i18n>
    </div>
    <div class="notifications-panel__tabs-actions">
      <notifications-panel-tabs
        class="notifications-panel__tabs"
        :value="tab"
        :meta="meta"
        @change="onTabChange"
      />
      <notifications-panel-actions
        class="notifications-panel__actions"
        :selected-tab="tab"
        @close="$emit('close')"
      />
    </div>
    <div class="notifications-panel__body">
      <notifications-panel-content class="notifications-panel__content" :tab="tab" @close="$emit('close')" />
    </div>
  </div>
</template>

<script>
import NotificationsPanelTabs from '@/components/modules/notifications/panel/notifications-panel-tabs.vue'
import NotificationsPanelContent from '@/components/modules/notifications/panel/notifications-panel-content.vue'
import NotificationsPanelActions from '@/components/modules/notifications/panel/notifications-panel-actions.vue'
import NotificationIcon from '@/assets/icons/NotificationIcon.vue'
import CloseRegularIcon from '@/assets/icons/CloseRegularIcon.vue'
import LLButton from '@/components/common/ui-components/LLButton.vue'
import { HELP_NOTIFICATIONS_URL } from '@/common/helpLinks'

export default {
  name: 'NotificationsPanel',
  components: {
    LLButton,
    CloseRegularIcon,
    NotificationIcon,
    NotificationsPanelActions,
    NotificationsPanelContent,
    NotificationsPanelTabs
  },
  props: {
    meta: { type: Object, default: () => ({ total: undefined, unread: undefined }) }
  },
  data() {
    return {
      tab: 'all',
      isPending: false
    }
  },
  computed: {
    helpNotificationsUrl() {
      return HELP_NOTIFICATIONS_URL
    }
  },
  methods: {
    onTabChange(key) {
      this.tab = key
    }
  }
}
</script>

<style scoped lang="scss">
.notifications-panel {
  @apply border border-neutral-01-100 shadow rounded px-4 flex flex-col pt-4;
  width: 400px;
  &__tabs-actions {
    @apply flex mt-1;
  }
  &__push-setup {
    @apply mt-2 mb-1;
    &-text {
      @apply text-body-02 text-neutral-01-500;
    }
    &-link {
      @apply underline;
    }
  }
  &__header {
    @apply flex justify-between;
  }
  &__title {
    @apply flex items-center;
    &-icon {
      @apply mr-2 text-primary-01-400;
    }
    &-text {
      @apply text-button-01 text-primary-01-400;
    }
  }
  &__close {
    @apply flex items-center;
    &-icon {
      @apply text-body-03;
    }
  }
  &__tabs {
    @apply flex-1;
  }
  &__body {
    @apply flex-1 overflow-y-auto py-4;
  }
  &__content {
    @apply h-full;
  }
}
</style>
